import { ComingSoonEmptyState } from '../../shell/empty-states/coming-soon-empty-state.js';

export function GameSettingsMilestonesPage(): JSX.Element {
  return (
    <ComingSoonEmptyState
      title="Milestones"
      description="Manage, create, edit, close, and browse milestones for this game. Lands with the Milestones story."
    />
  );
}
